/**
 * Menu, Search, Sticky Header, Overflow "More" Menu
 */
(function () {
  'use strict';

  // ===== Mobile Drawer =====
  var drawer = document.getElementById('mobileMenu');
  var menuBtn = document.getElementById('menuToggle');
  var menuClose = document.getElementById('menuClose');
  var mobileOverlay = document.getElementById('mobileOverlay');

  function openDrawer() {
    if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  }
  function closeDrawer() {
    if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  }

  if (menuBtn) menuBtn.addEventListener('click', openDrawer);
  if (menuClose) menuClose.addEventListener('click', closeDrawer);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeDrawer);
  window.closeMobileMenu = closeDrawer;

  // ===== Desktop Dropdown — close on outside click =====
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header__dropdown')) {
      document.querySelectorAll('.header__dropdown[open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  // ===== Detect layout type =====
  var headerSection = document.querySelector('.header-section');
  var headerLayout = headerSection ? headerSection.getAttribute('data-layout') : 'classic';

  // ===== Desktop Dropdown — hover + click to open =====
  function initHoverMenus() {
    if (window.innerWidth < 1100 || headerLayout === 'minimal') return;
    document.querySelectorAll('.header__menu-item.has-submenu, .header__more').forEach(function (item) {
      var details = item.querySelector('.header__dropdown');
      if (!details || item._hoverBound) return;
      item._hoverBound = true;
      var timer;
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        document.querySelectorAll('.header__dropdown[open]').forEach(function (d) { if (d !== details) d.removeAttribute('open'); });
        details.setAttribute('open', '');
      });
      item.addEventListener('mouseleave', function () {
        timer = setTimeout(function () { details.removeAttribute('open'); }, 200);
      });
      // Click toggle for touch devices
      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = details.hasAttribute('open');
          document.querySelectorAll('.header__dropdown[open]').forEach(function (d) { d.removeAttribute('open'); });
          if (!isOpen) details.setAttribute('open', '');
        });
      }
    });
  }

  // ===== Overflow "Daha Fazla" Menu =====
  function initOverflowMenu() {
    var menu = document.getElementById('headerMenu');
    var moreItem = document.getElementById('headerMore');
    var moreDrop = document.getElementById('headerMoreDropdown');
    var headerEl = document.getElementById('header');

    // Mobile or minimal layout — skip
    if (!menu || !moreItem || !moreDrop || window.innerWidth < 1100 || headerLayout === 'minimal') {
      if (moreItem) moreItem.style.display = 'none';
      return;
    }

    // Step 1: Reset — show all, hide more
    var items = Array.from(menu.querySelectorAll('.header__menu-item:not(.header__more)'));
    items.forEach(function (item) {
      item.style.display = '';
      item.style.visibility = 'visible';
    });
    moreItem.style.display = 'none';
    moreDrop.innerHTML = '';

    // Step 2: Calculate available width
    requestAnimationFrame(function () {
      if (!headerEl) return;

      // Get logo and icons width
      var logo = headerEl.querySelector('.header__center');
      var icons = headerEl.querySelector('.header__right');
      var headerWidth = headerEl.offsetWidth;
      var logoWidth = logo ? logo.offsetWidth : 0;
      var iconsWidth = icons ? icons.offsetWidth : 0;
      var padding = 80; // extra safety margin
      var moreButtonWidth = 56;

      var availableWidth = headerWidth - logoWidth - iconsWidth - padding;

      // Step 3: Measure each item
      var usedWidth = 0;
      var overflowItems = [];

      items.forEach(function (item) {
        var itemWidth = item.getBoundingClientRect().width;
        usedWidth += itemWidth;

        if (usedWidth > availableWidth - moreButtonWidth) {
          overflowItems.push(item);
        }
      });

      // Step 4: No overflow — done
      if (overflowItems.length === 0) {
        moreItem.style.display = 'none';
        return;
      }

      // Step 5: Hide overflow items and build dropdown
      var isFirst = true;
      overflowItems.forEach(function (item) {
        item.style.display = 'none';

        var summary = item.querySelector('summary');
        var link = item.querySelector('a.header__menu-link');

        // Add separator between groups
        if (!isFirst) {
          var sep = document.createElement('span');
          sep.className = 'hm-sep';
          moreDrop.appendChild(sep);
        }
        isFirst = false;

        if (summary) {
          // Has submenu — add styled heading + child links
          var heading = document.createElement('span');
          heading.className = 'hm-heading';
          heading.textContent = summary.textContent.trim();
          moreDrop.appendChild(heading);

          item.querySelectorAll('.header__submenu-link').forEach(function (sl) {
            var a = document.createElement('a');
            a.href = sl.href;
            a.textContent = sl.textContent.trim();
            moreDrop.appendChild(a);
          });
        } else if (link) {
          // Simple link
          var a = document.createElement('a');
          a.href = link.href;
          a.textContent = link.textContent.trim();
          moreDrop.appendChild(a);
        }
      });

      moreItem.style.display = '';
      // Re-bind hover/click on the newly visible more button
      initHoverMenus();
    });
  }

  // ===== Search Popup =====
  var searchPopup = document.getElementById('searchPopup');
  var searchBtn = document.getElementById('searchToggle');
  var searchClose = document.getElementById('searchClose');
  var searchOverlay = document.getElementById('searchOverlay');
  var searchInput = document.getElementById('searchInput');
  var searchClear = document.getElementById('searchClear');
  var searchResults = document.getElementById('searchResults');
  var searchResultsContent = document.getElementById('searchResultsContent');
  var searchLoading = document.getElementById('searchLoading');
  var searchPopular = document.getElementById('searchPopular');

  function openSearch() {
    if (searchPopup) { searchPopup.classList.add('is-open'); if(searchPopup.querySelector('.sf__default')) searchPopup.querySelector('.sf__default').style.display = ''; document.body.style.overflow = 'hidden'; }
    if (searchInput) setTimeout(function() { searchInput.focus(); }, 100);
  }
  function closeSearch() {
    if (searchPopup) { searchPopup.classList.remove('is-open'); document.body.style.overflow = ''; }
    if (searchResults) searchResults.style.display = 'none';
    if (searchPopular) searchPopular.style.display = '';
  }

  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);
  window.closeSearchPopup = closeSearch;

  // Clear button
  if (searchClear && searchInput) {
    searchClear.addEventListener('click', function() {
      searchInput.value = '';
      searchClear.style.display = 'none';
      if (searchResults) searchResults.style.display = 'none';
      if (searchPopular) searchPopular.style.display = '';
      searchInput.focus();
    });
  }

  // Predictive search
  var searchTimer;
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      var q = searchInput.value.trim();

      // Show/hide clear button
      if (searchClear) searchClear.style.display = q.length > 0 ? '' : 'none';

      if (q.length < 2) {
        if (searchResults) searchResults.style.display = 'none';
        if (searchPopular) searchPopular.style.display = '';
        return;
      }

      clearTimeout(searchTimer);
      searchTimer = setTimeout(function() {
        if (searchLoading) searchLoading.style.display = '';
        if (searchResults) searchResults.style.display = '';
        if (searchPopular) searchPopular.style.display = 'none';

        fetch(window.routes.search_url + '?q=' + encodeURIComponent(q) + '&type=product&resources[type]=product&resources[limit]=8&section_id=predictive-search')
          .then(function(r) { return r.text(); })
          .catch(function() {
            // Fallback: use search.json
            return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
              .then(function(r) { return r.json(); })
              .then(function(data) {
                var products = data.resources && data.resources.results && data.resources.results.products || [];
                if (products.length === 0) return '<div class="search-popup__no-results">Sonuç bulunamadı</div>';

                var html = '<div class="search-popup__result-grid">';
                products.forEach(function(p) {
                  var img = p.image || '';
                  var price = p.price ? (parseFloat(p.price)/100).toFixed(2).replace('.',',') + '₺' : '';
                  html += '<a href="' + p.url + '" class="search-popup__result-item">';
                  if (img) html += '<div class="search-popup__result-img"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>';
                  html += '<div class="search-popup__result-info"><span class="search-popup__result-title">' + p.title + '</span><span class="search-popup__result-price">' + price + '</span></div></a>';
                });
                html += '</div><a href="' + window.routes.search_url + '?q=' + encodeURIComponent(q) + '" class="search-popup__view-all">Tüm sonuçları gör →</a>';
                return html;
              });
          })
          .then(function(html) {
            if (searchResultsContent) searchResultsContent.innerHTML = html;
            if (searchLoading) searchLoading.style.display = 'none';
          });
      }, 300);
    });
  }

  // ===== Escape =====
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeSearch(); }
  });

  // ===== Sticky Header =====
  var headerBar = document.getElementById('headerBar');
  if (headerBar) {
    var lastScrollY = 0;
    var scrollTicking = false;
    var entranceDone = false;

    // Wait for entrance animation to finish before allowing scroll transforms
    headerBar.addEventListener('animationend', function () {
      entranceDone = true;
    });
    // Fallback if animation is already done
    setTimeout(function () { entranceDone = true; }, 800);

    function updateHeader() {
      var scrollY = window.scrollY;
      headerBar.classList.toggle('is-scrolled', scrollY > 60);

      // Hide header on scroll down, show on scroll up (mobile only)
      if (entranceDone && window.innerWidth < 750) {
        if (scrollY > lastScrollY && scrollY > 200) {
          headerBar.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
          headerBar.style.transform = 'translateY(-100%)';
        } else {
          headerBar.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
          headerBar.style.transform = 'translateY(0)';
        }
      }

      lastScrollY = scrollY;
      scrollTicking = false;
    }

    window.addEventListener('scroll', function () {
      if (!scrollTicking) {
        requestAnimationFrame(updateHeader);
        scrollTicking = true;
      }
    }, { passive: true });
  }

  // ===== Init =====
  function init() {
    initOverflowMenu();
    initHoverMenus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Small delay to ensure fonts/layout are ready
    setTimeout(init, 100);
  }

  // Re-run on resize (debounced)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 300);
  });
})();
